<ng-container *ngFor="let filter of filters">
    <div>
        <label>{{ filter.title }}</label>
    </div>
    <div class="d-flex justify-content-between">
        <div>
            <div class="d-flex flex-wrap align-items-center">
                <div class="datepicker-container">
                    <label>Starting Date</label>
                    <input
                        (click)="startDate.open()"
                        [matDatepicker]="startDate"
                        class="form-control date d-inline-block"
                        color="accent"
                        [(ngModel)]="filter.startDate"
                        placeholder="Start Date"
                    />
                    <mat-datepicker #startDate></mat-datepicker>
                </div>

                <label class="mx-2 mb-2 align-self-end"> to </label>

                <div class="datepicker-container">
                    <label>Ending Date</label>
                    <input
                        (click)="endDate.open()"
                        [matDatepicker]="endDate"
                        class="form-control date d-inline-block"
                        color="accent"
                        [(ngModel)]="filter.endDate"
                        placeholder="End Date"
                    />
                    <mat-datepicker #endDate></mat-datepicker>
                </div>
            </div>
        </div>
        <div>
            <label>Shortcuts</label>

            <div class="flex-wrap d-flex justify-content-between">
                <div class="btn-group mr-3">
                    <button
                        (click)="_filteringService.setLastMonthDatePickers([filter]); parentReloadReport()"
                        class="btn btn-outline-secondary"
                    >
                        Last Month
                    </button>
                    <button
                        (click)="_filteringService.setThisMonthDatePickers([filter]); parentReloadReport()"
                        class="btn btn-outline-secondary"
                    >
                        This Month
                    </button>
                    <button
                        *ngIf="showNext"
                        (click)="_filteringService.setNextMonthDatePickers([filter]); parentReloadReport()"
                        class="btn btn-outline-secondary"
                    >
                        Next Month
                    </button>
                </div>

                <div class="btn-group mr-3">
                    <button
                        (click)="_filteringService.setLastCalendarYearDatePickers([filter]); parentReloadReport()"
                        class="btn btn-outline-secondary"
                    >
                        Last Year
                    </button>
                    <button
                        (click)="_filteringService.setThisCalendarYearDatePickers([filter]); parentReloadReport()"
                        class="btn btn-outline-secondary"
                    >
                        This Year
                    </button>
                    <button
                        *ngIf="showNext"
                        (click)="_filteringService.setNextCalendarYearDatePickers([filter]); parentReloadReport()"
                        class="btn btn-outline-secondary"
                    >
                        Next Year
                    </button>
                </div>

                <div class="btn-group">
                    <button
                        (click)=" _filteringService.setLastFiscalYearDatePickers([filter], fiscalStartMonth); parentReloadReport()"
                        class="btn btn-outline-secondary"
                    >
                        Last Fiscal Year
                    </button>
                    <button
                        (click)="  _filteringService.setThisFiscalYearDatePickers([filter], fiscalStartMonth); parentReloadReport()"
                        class="btn btn-outline-secondary"
                    >
                        This Fiscal Year
                    </button>
                    <button
                        *ngIf="showNext"
                        (click)="_filteringService.setNextFiscalYearDatePickers([filter], fiscalStartMonth); parentReloadReport()"
                        class="btn btn-outline-secondary"
                    >
                        Next Fiscal Year
                    </button>

                    <i class="fa fa-info-circle add-hover"
                       style="margin-top: 10px;"
                       matTooltip="Current Fiscal Year:  {{ getCurrentFiscalYearDisplay() }}"></i>
                </div>
            </div>
            <div class="text-right">
                <a class="btn btn-link" *ngIf="isAdmin" [routerLink]="['/app/settings/organization']">
                    <i class="fa fa-external-link"></i>
                    Manage FY</a>
            </div>

        </div>

    </div>
</ng-container>
